import actions from './actions';

const {
  getAllProductBegin,
  getAllProductSuccess,
  getAllProductErr,
  setAllProductBegin,
  setAllProductSuccess,
  setAllProductErr,
  getSelectedProductBegin,
  getSelectedProductSuccess,
  getSelectedProductErr,
  setSelectedProductBegin,
  setSelectedProductSuccess,
  setSelectedProductErr,
} = actions;

const getAllProductAction = () => {
  return async dispatch => {
    try {
      dispatch(getAllProductBegin());
      dispatch(getAllProductSuccess());
    } catch (err) {
      dispatch(getAllProductErr(err));
    }
  };
};

const setAllProductAction = allProduct => {
  return async dispatch => {
    try {
      dispatch(setAllProductBegin());
      dispatch(setAllProductSuccess(allProduct));
    } catch (err) {
      dispatch(setAllProductErr(err));
    }
  };
};

const setSelectedProductAction = selectedProduct => {
  return async dispatch => {
    try {
      dispatch(setSelectedProductBegin());
      dispatch(setSelectedProductSuccess(selectedProduct));
    } catch (err) {
      dispatch(setSelectedProductErr(err));
    }
  };
};

const getSelectedProductAction = () => {
  return async dispatch => {
    try {
      dispatch(getSelectedProductBegin());
      dispatch(getSelectedProductSuccess());
    } catch (err) {
      dispatch(getSelectedProductErr(err));
    }
  };
};

export { getAllProductAction, setAllProductAction, setSelectedProductAction, getSelectedProductAction };

